import clx from 'classnames';
import type * as React from 'react';
import { down } from 'styled-breakpoints';
import styled, { useTheme } from 'styled-components';

const StyledContentLayoutWrapper = styled.div`
  width: 100%;
  &.has-padding {
    padding: 24px;
    /* &.boxed-layout {
      padding: 24px 0;
    } */
  }
  &.top-padding {
    padding-top: 24px;
  }
  &.boxed-layout {
    max-width: ${props => props.theme.contentMaxWidth}px;
    margin: 0 auto;
  }
  &.is-table-page,
  &.boxed-layout.is-table-page {
    &.table-page-full-width {
      max-width: 100%;
      margin: 0;
      &.padding-in-table-page-full-width {
        padding-inline: 24px;
        ${down('sm')} {
          padding-inline: 12px;
        }
      }
    }
  }
`;

export interface ContentLayoutWrapperProps
  extends React.HTMLAttributes<HTMLDivElement> {
  boxed?: boolean;
  padded?: boolean;
  // fix per aggiungere il padding in testa alla pagina
  // dopo l'inserimento dell'affix header
  topPadding?: boolean;
  /**
   * Indica se il layout ha un contenuto di tipo tabella
   */
  isTablePage?: boolean;
  paddingInTablePageFullWidth?: boolean;
}

/**
 * Wrapper del Layout che definisce la larghezza massima del contenuto.
 */
export function ContentLayoutWrapper(props: ContentLayoutWrapperProps) {
  const {
    boxed,
    className,
    padded,
    topPadding,
    isTablePage = false,
    paddingInTablePageFullWidth = true,
    ...divProps
  } = props;
  const theme = useTheme();
  return (
    <StyledContentLayoutWrapper
      className={clx(className, {
        'boxed-layout': boxed,
        'has-padding': padded,
        'top-padding': topPadding,
        'is-table-page': isTablePage,
        'table-page-full-width': theme.tablePageFullWidthFlag,
        'padding-in-table-page-full-width': paddingInTablePageFullWidth,
      })}
      {...divProps}
    >
      {props.children}
    </StyledContentLayoutWrapper>
  );
}
